import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async getDeptMngList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getDeptMngList({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	}
};
